"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["placeholder", "items", "color", "name", "valueProperty", "textProperty", "disabled"],

  data: function data() {
    return {
      selected: ""
    };
  },


  watch: {
    selected: function selected() {
      this.$emit("change", this.selected);
    }
  },

  computed: {
    classes: function classes() {
      var baseClasses = ["dropdown-wrapper", "clearfix"];

      if (this.color) {
        baseClasses.push("-" + this.color);
      }

      return baseClasses;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/DropdownField.vue
// module id = POH6
// module chunks = 0 1